(function ($) {
    'use strict';

    const hiddenClass = 'hidden',
        defaults = {
            'min': 1,
            'max': 5,
            'empty-value': 0,
            'iconLib': 'k-icon k-font-icon',
            'activeIcon': 'k-i-star',
            'inactiveIcon': 'k-i-star-outline',
            'clearable': false,
            'color': '#4f8def',
            'clearableIcon': 'fa fa-minus-circle',
            'clearableRemain': true,
            'inline': false,
            'readonly': false,
            'copyClasses': true
        };

    const clearSelector = '[data-value="1"]';

    function starSelector(value) {
        return `[data-value${value ? (`=${value}`) : ''}]`;
    }

    function toggleActive($el, active, options) {
        const activeClass = options.activeIcon;
        const inactiveClass = options.inactiveIcon;
        $el.removeClass(active ? inactiveClass : activeClass).addClass(active ? activeClass : inactiveClass);
    }

    function parseOptions($input, options) {
        const data = $.extend({}, defaults, $input.data(), options);
        data.inline = data.inline === '' || data.inline;
        data.readonly = data.readonly === '' || data.readonly;
        if (data.clearable === false) {
            data.clearableLabel = '';
        } else {
            data.clearableLabel = data.clearable;
        }
        data.clearable = data.clearable === '' || data.clearable;
        return data;
    }

    function createRatingEl($input, options) {
        // Inline option
        let $ratingEl;
        if (options.inline) {
            $ratingEl = $('<span class="rating-input"></span>');
        } else {
            $ratingEl = $('<div class="rating-input"></div>');
        }

        // Copy original classes but the rating class
        if (options.copyClasses) {
            $ratingEl.addClass($input.attr('class'));
            $ratingEl.removeClass('rating');
        }

        // Render rating icons
        for (let i = options.min; i <= options.max; i++) {
            $ratingEl.append(`<i class="${options.iconLib}" data-value="${i}" style="color:${options.color}"></i>`);
        }

        // Render clear link
        //if (options.clearable && !options.readonly) {
        //  $ratingEl.append('&nbsp;').append(
        //    '<a class="' + clearClass + '">' +
        //      '<i class="' + options.iconLib + ' ' + options.clearableIcon + '"/>' +
        //      options.clearableLabel +
        //    '</a>'
        //  );
        //}
        return $ratingEl;
    }

    const Rating = function (input, options) {
        const $input = this.$input = input;
        this.options = parseOptions($input, options);
        const $ratingEl = this.$el = createRatingEl($input, this.options);
        $input.addClass(hiddenClass).before($ratingEl);
        $input.attr('type', 'hidden');
        this.highlight($input.val());
    };

    Rating.VERSION = '0.4.0';

    Rating.DEFAULTS = defaults;

    Rating.prototype = {

        clear: function () {
            this.setValue(this.options['empty-value']);
        },

        setValue: function (value) {
            if (value !== 1) {
                this.highlight(value);
                this.updateInput(value);
            }
        },

        highlight: function (value) {
            const options = this.options;
            const $el = this.$el;
            if (value >= this.options.min && value <= this.options.max) {
                const $selected = $el.find(starSelector(value));
                toggleActive($selected.prevAll('i').addBack(), true, options);
                toggleActive($selected.nextAll('i'), false, options);
            } else {
                toggleActive($el.find(starSelector()), false, options);
            }
        },

        updateInput: function (value) {
            const $input = this.$input;
            if ($input.val() !== value) {
                $input.val(value).change();
            }
        }
    };

    const plugin = $.fn.rating = function (options) {
        return this.filter('input[type=number]').each(function () {
            const $input = $(this);
            const optionsObject = typeof options === 'object' && options || {};
            const rating = new Rating($input, optionsObject);
            if (!rating.options.readonly) {
                rating.$el
                    .on('mouseenter', starSelector(), function () {
                        rating.highlight($(this).data('value'), true);
                    })
                    .on('mouseleave', starSelector(), function () {
                        rating.highlight($input.val(), true);
                    })
                    .on('click', starSelector(), function () {
                        rating.setValue($(this).data('value'));
                    })
                    .on('click', clearSelector, function () {
                        if ($input.val() === '') {
                            $input.val(1).change();
                            return;
                        }
                        rating.clear();
                        rating.setValue($(this).data('0'));
                    });
            }
        });
    };

    plugin.Constructor = Rating;

    $(function () {
        $('input.rating[type=number]').each(function () {
            $(this).rating();
        });
    });

}(jQuery));